/* eslint-disable react/jsx-props-no-spreading */
const StepThreeIcon = (props) => (
	<svg width={128} height={120} viewBox="0 0 128 120" {...props}>
		<g fill="none" fillRule="evenodd">
			<circle cx="60" cy="60" r="60" fill="#FFF" opacity=".327" />
			<path
				fill="#FFF"
				stroke="#4D3951"
				strokeWidth="3"
				d="M87 73.5H33c-1.519 0-2.894.616-3.89 1.61-.994.996-1.61 2.371-1.61 3.89v6.5h65V79c0-1.519-.616-2.894-1.61-3.89-.996-.994-2.371-1.61-3.89-1.61z"
			/>
			<path
				fill="#FFF"
				stroke="#4D3951"
				strokeWidth="3"
				d="M68 69.5H52c-2.347 0-4.472.951-6.01 2.49-1.539 1.538-2.49 3.663-2.49 6.01v7.5h33V78c0-2.347-.951-4.472-2.49-6.01-1.538-1.539-3.663-2.49-6.01-2.49z"
			/>
			<circle
				cx="60"
				cy="52"
				r="11.5"
				fill="#FFF"
				stroke="#4D3951"
				strokeWidth="3"
			/>
			<circle
				cx="82"
				cy="62"
				r="6.5"
				fill="#FFF"
				stroke="#4D3951"
				strokeWidth="3"
			/>
			<circle
				cx="38"
				cy="62"
				r="6.5"
				fill="#FFF"
				stroke="#4D3951"
				strokeWidth="3"
			/>
			<path
				fill="#83BDE4"
				stroke="#4D3951"
				strokeWidth="3"
				d="M61.807 75.5h-3.614l-2.307 10h8.228l-2.307-10zM61.919 75.5H58.08l-2-6h7.838l-2 6z"
			/>
			<g transform="translate(88)">
				<circle cx="20" cy="20" r="20" fill="#FFF" />
				<text
					fill="#373737"
					fontFamily="Inter"
					fontSize="24"
					fontWeight="700"
				>
					<tspan x="13.616" y="28">
						3
					</tspan>
				</text>
			</g>
		</g>
	</svg>
);

export default StepThreeIcon;
